// extracted by mini-css-extract-plugin
export default {"expenseItem":"ExpenseItem_expenseItem__LLgdw","badge":"ExpenseItem_badge__Nl5oV"};